<template>
  <section
    class="viewsrhqyClockManage_ClockDetail p-4 h-full overflow-y-auto overflow-x-hidden space-y-4"
  >
    <viewTitle
      title="业务管理 / 发货打卡管理 / 查看发货打卡记录"
      :showReturn="true"
    />
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="订单号" prop="order_code">
        <el-input
          class="w-96"
          v-if="pageType === 'edit'"
          v-model="form.order_code"
          placeholder="请输入订单号"
        ></el-input>
        <span class="text-gray-500" v-else>{{ form.order_code }}</span>
      </el-form-item>
      <el-form-item label="是否区域价" prop="is_area_price">
        <span class="text-gray-500">{{ form.is_area_price || "否" }}</span>
      </el-form-item>
      <el-form-item label="木片类型" prop="chip_type">
        <el-input
          class="w-96"
          v-if="pageType === 'edit'"
          v-model="form.chip_type"
          placeholder="请输入木片类型"
        ></el-input>
        <span class="text-gray-500" v-else>{{ form.chip_type }}</span>
      </el-form-item>
      <el-form-item label="送货单号" prop="deliver_code">
        <span class="text-gray-500">{{ form.deliver_code || "--" }}</span>
      </el-form-item>
      <el-form-item label="基地" prop="company_name">
        <span class="text-gray-500">{{ form.company_name || "--" }}</span>
      </el-form-item>
      <el-form-item label="账号" prop="account">
        <span class="text-gray-500">{{ form.account || "--" }}</span>
      </el-form-item>
      <el-form-item label="供应商编号" prop="supplier_code">
        <span class="text-gray-500">{{ form.supplier_code || "--" }}</span>
      </el-form-item>
      <el-form-item label="供应商名称" prop="supplier_name">
        <span class="text-gray-500">{{ form.supplier_name || "--" }}</span>
      </el-form-item>
      <el-form-item label="木片厂名" prop="chip_name">
        <span class="text-gray-500">{{ form.chip_name || "--" }}</span>
      </el-form-item>
      <el-form-item label="联系人" prop="contact">
        <span class="text-gray-500">{{ form.contact || "--" }}</span>
      </el-form-item>
      <el-form-item label="车头车牌号" prop="license_plate">
        <el-input
          class="w-96"
          v-model="form.license_plate"
          :maxlength="8"
          v-if="pageType === 'edit'"
          placeholder="请输入车头车牌号"
        ></el-input>
        <span class="text-gray-500" v-else>{{ form.license_plate }}</span>
      </el-form-item>
      <el-form-item label="集装箱号" prop="container_number">
        <el-input
          class="w-96"
          v-model="form.container_number"
          v-if="pageType === 'edit' && canEditContainerNumber"
          placeholder="请输入集装箱号"
        ></el-input>
        <span class="text-gray-500" v-else>{{ form.container_number || "--" }}</span>
      </el-form-item>
      <el-form-item label="数据来源" prop="position_source">
        <span class="text-gray-500">
          {{ form.position_source == 1 ? "北斗" : "APP" }}
          ({{
            form.type == 1 ? "正常" : form.type == 2 ? "白名单" : "未预约车辆"
          }})
        </span>
      </el-form-item>
      <el-form-item label="打卡时间" prop="clock_time">
        <span class="text-gray-500">{{ form.clock_time | timeFormat }}</span>
      </el-form-item>
      <el-form-item label="打卡地点" prop="address">
        <span class="text-gray-500">{{ form.address || "--" }}</span>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-radio-group v-model="form.state" v-if="pageType === 'edit'">
          <el-radio
            v-for="(label, value) in stateMap"
            :key="value"
            :label="Number(value)"
            >{{ label }}</el-radio
          >
        </el-radio-group>
        <span v-else class="text-gray-500">{{
          form.state | formatState(stateMap)
        }}</span>
      </el-form-item>
      <el-form-item label="是否传输SAP" prop="is_push_sap">
        <span class="text-gray-500">{{
          form.is_push_sap == 1 ? "是" : "否"
        }}</span>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <span class="text-gray-500">{{ form.remark || "--" }}</span>
      </el-form-item>
      <el-form-item label="图片" prop="files">
        <template v-if="form.files.length > 0">
          <div class="inline-flex flex-wrap" style="width: 590px">
            <el-image
              v-for="file in form.files"
              :key="file.id"
              style="width: 150px; height: 150px"
              :src="file.real_path"
              :preview-src-list="previewSrcList"
              fit="fill"
              class="mr-2 mb-2"
            >
              <template slot="error">
                <div class="el-image__error" style="flex-direction: column;line-height: 2;">
                  <span>加载失败</span>
                  <el-button @click.stop="onDownload(file.real_path)" size="mini" type="primary">下载</el-button>
                </div>
              </template>
            </el-image>
          </div>
        </template>
        <span class="text-gray-500" v-else>--</span>
      </el-form-item>
      <el-form-item label="备注" prop="booking_code">
        <c-link :underline="true" @click="onBookingDetail">{{
          form.booking_code
        }}</c-link>
      </el-form-item>
    </el-form>
    <div style="height: 56px;"></div>
    <div
      class="absolute bottom-0 left-0 space-x-4 bg-white w-full px-4 py-2 box-border z-50 border-t border-solid border-gray-200"
      v-if="pageType === 'edit'"
    >
      <el-button @click="onSave" size="medium" class="w-20" type="primary"
        >保 存</el-button
      >
      <el-button @click="onBack" size="medium" class="w-20">取 消</el-button>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  props: {},

  data() {
    return {
      form: {
        files: []
      },
      stateMap: {
        1: "未进厂",
        2: "已进厂",
        3: "已出厂"
      }
    };
  },

  computed: {
    ...mapGetters(["baseInfo", "privilegeConfig"]),
    pageType() {
      return this.$route.params.pageType;
    },
    recordId() {
      return this.$route.params.id;
    },
    canEditContainerNumber() {
      if (!this.privilegeConfig || !Array.isArray(this.privilegeConfig.keys)) {
        return false;
      }
      return this.privilegeConfig.keys.includes("c-clock-record-containerUpdate");
    },
    rules() {
      if (this.pageType === "edit") {
        return {
          order_code: [
            { required: true, message: "请输入订单号", trigger: "blur" }
          ],
          chip_type: [
            { required: true, message: "请输入木片类型", trigger: "blur" }
          ],
          license_plate: [
            { required: true, message: "请输入车牌号", trigger: "blur" }
          ],
          container_number: [
            { validator: this.validateContainerNumber, trigger: "blur" }
          ],
          state: [{ required: true, message: "请选择状态", trigger: "change" }]
        };
      }
      return {};
    },
    previewSrcList() {
      if (this.form.files && this.form.files.length > 0) {
        return this.form.files.map(item => item.real_path);
      }
      return [];
    }
  },

  filters: {
    formatState(state, map) {
      return map[state] || "--";
    },
    timeFormat(time, style = "YYYY-MM-DD HH:mm:ss") {
      return moment.unix(time).format(style);
    },
    formatAddress(data) {
      const { province, city, district } = data;
      if (province && city && district) {
        return `${province}${city}${district}`;
      }
      return "--";
    }
  },

  components: {},

  mixins: [],

  beforeCreate() {},

  created() {
    this.getDetail();
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    /**
     * 校验集装箱号格式，允许为空，非空时必须为 4 位字母 + 7 位数字。
     */
    validateContainerNumber(rule, value, callback) {
      if (!this.canEditContainerNumber) {
        callback();
        return;
      }
      const normalizedValue = String(value || "")
        .trim()
        .toUpperCase();
      if (!normalizedValue) {
        callback();
        return;
      }
      if (!/^[A-Z]{4}\d{7}$/.test(normalizedValue)) {
        callback(new Error("集装箱号需为4位字母+7位数字"));
        return;
      }
      callback();
    },
    onBookingDetail() {
      window.open(
        this.$router.resolve(
          `/rhqy/service/AppointDeliveryRecord/Detail/${this.form.booking_info_id}`
        ).href,
        "_blank"
      );
    },
    onDownload(url) {
      window.open(url);
    },
    getDetail() {
      this.$common
        .http({
          url: "/api/queue/admin/detail_booking_clock",
          data: {
            id: this.recordId
          }
        })
        .then(res => {
          this.form = res.data.data;
        });
    },
    onSave() {
      this.$refs["form"].validate(v => {
        if (v) {
          this.$confirm("确认修改？").then(async () => {
            // 关键步骤：前端保存前先转成大写，减少用户输入小写时被后端格式校验拦截。
            this.form.container_number = String(this.form.container_number || "")
              .trim()
              .toUpperCase();
            const {
              id,
              order_code,
              chip_type,
              license_plate,
              state,
              container_number
            } = this.form;
            try {
              await this.$common.http({
                url: "/api/queue/admin/update_booking_clock",
                data: {
                  id,
                  order_code,
                  chip_type,
                  license_plate,
                  state,
                  container_number
                }
              });
              this.$message.success("修改成功");
              this.onBack();
            } catch (error) {}
          });
        }
      });
    },
    onBack() {
      this.$router.back();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
/deep/ .el-form-item {
  margin-bottom: 0;
}
/deep/ .el-form-item.is-error {
  margin-bottom: 22px;
}
</style>
